import { Reveal, SectionHeader } from "./Reveal";
import PhotoFrame from "./PhotoFrame";
import kitImg from "../assets/photos/kit.jpg";
import canecaImg from "../assets/photos/caneca.jpg";
import dryfitImg from "../assets/photos/dryfit.jpg";
import chaveiroImg from "../assets/photos/chaveiro.jpg";
import camisaPretaImg from "../assets/photos/camisa-preta.jpg";
import { CATEGORIES } from "../lib/site";

const CAT_IMGS = [kitImg, canecaImg, dryfitImg, camisaPretaImg, null, chaveiroImg];

export default function Categories() {
    return (
        <section
            id="o-que-fazemos"
            className="bg-white py-20 sm:py-28 lg:py-32"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
                    <SectionHeader
                        eyebrow="O que fazemos"
                        title={
                            <>
                                Personalizados para
                                <br />
                                <span className="italic text-gold-deep">
                                    cada momento
                                </span>
                            </>
                        }
                        sub="Na Magnus Personalizados, cada produto é pensado para ser único. Personalizamos presentes, produtos para eventos, empresas, grupos e ocasiões especiais, transformando sua ideia em algo feito especialmente para você."
                    />
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mt-14 lg:mt-20">
                    {CATEGORIES.map((cat, i) => (
                        <Reveal
                            key={cat.title}
                            delay={0.06 * i}
                            testId={`category-card-${i + 1}`}
                        >
                            <article className="group h-full flex flex-col">
                                <PhotoFrame
                                    img={CAT_IMGS[i]}
                                    label={cat.title}
                                    ratio="aspect-[4/3]"
                                    testId={`category-frame-${i + 1}`}
                                />
                                <div className="flex items-start gap-4 mt-6 flex-1">
                                    <span className="font-display text-2xl text-gold/70 leading-none pt-1">
                                        {String(i + 1).padStart(2, "0")}
                                    </span>
                                    <div>
                                        <h3 className="font-display text-xl sm:text-2xl font-medium text-ink group-hover:text-gold-deep transition-colors">
                                            {cat.title}
                                        </h3>
                                        <p className="font-body text-sm text-inksoft leading-relaxed mt-2">
                                            {cat.desc}
                                        </p>
                                    </div>
                                </div>
                            </article>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
